import {styled, clsx} from 'external/material'
import {inViewer} from 'settings'

import { centerVertically } from 'utils/style'
import {viewerGuard, subdomainLink} from 'utils/url'
import {logLessonAccess} from 'utils/lesson'

import {DownloadIcon, SquareArrowUpRightIcon} from 'resources/icons'

const StyledDashboardActivityItemLink = styled('div')(dashboardActivityItemLinkStyles)

export default function DashboardActivityItemDownload(props) {
    const {hasEpl, type, downloaded, dummy} = props
    
return(<StyledDashboardActivityItemLink className={clsx(type, props.className)}>
        {dummy && (
            <a className={clsx("link", "view")} style={{visibility: 'hidden'}}>
                <div className="icon-container">
                    <SquareArrowUpRightIcon fill="#2c75bd" height={20} />
                </div>
            </a>
        )} 
        {hasEpl && inViewer && downloaded && (
            <a className={clsx("link", "view")} href={`//downloads/${props.lesson}`}>
                <div className="icon-container">
                    <SquareArrowUpRightIcon fill="#2c75bd" height={20} />
                </div>
            </a>
        )} 
        {hasEpl && inViewer && !downloaded && (
            <a
              className={clsx("link", "download")}
              onClick={logLessonAccess('download', {...props, id: props.lesson})}
              {...viewerGuard({target: "_blank", href: subdomainLink('api-support', 'catalog',  'download', `?lesson=${props.lesson}`)})}
            >
            <div className="icon-container">
                <DownloadIcon fill="#2c75bd" width={16} />
            </div>
        </a>)}
        </StyledDashboardActivityItemLink>
   )
}

function dashboardActivityItemLinkStyles(){
    return {
        ...centerVertically,
        padding: 0,
        "& > .link": {
            ...centerVertically,
            borderRadius: 100,
            width: 40,
            height: 40,
            '& .icon-container': {
                display: 'flex',
                justifyContent: 'center'
            },
            cursor: 'pointer',
            backgroundColor: '#edeff4',
            '& .link': {
                textDecoration: 'none',
                color: '#fff',
            },
        }
    }
}